import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 手机号验证码登录
export function padphoneauth (phone, code) {
  return request({
    url: '/pad/auth',
    method: 'post',
    data: {
      phone,
      code
    }
  })
}
export function padselectusertype (typetag, muid) {
  return request({
    url: '/pad/selectusertype',
    method: 'post',
    data: {
      typetag,
      muid
    }
  })
}

// 获取楼栋房间
export function getpadlistroom (data) {
  return request({ url: '/pad/listroom', method: 'post', params: { token: getToken() }, data })
}

// 获取人员
export function getpadlistperson (data) {
  return request({ url: '/pad/listperson', method: 'post', params: { token: getToken() }, data })
}

// 获取服务人员
export function getpadlistserviceperson (data) {
  return request({ url: '/pad/listserviceperson', method: 'post', params: { token: getToken() }, data })
}

// 增加服务记录
export function addservicerecord (data) {
  return request({ url: '/pad/addservicerecord', method: 'post', params: { token: getToken() }, data })
}

// 更新用药状态
export function updatepadmedrecord (data) {
  return request({ url: '/pad/updatemedrecord', method: 'post', params: { token: getToken() }, data })
}



// WEBPACK FOOTER //
// ./src/api/pad/pad.js